const FETCH_DELTA_CONFIG_SUCCESS = 'FETCH_DELTA_CONFIG_SUCCESS';

export { FETCH_DELTA_CONFIG_SUCCESS };
